import {
	PULL_ARCHIVE_ERROR,
	PULL_ARCHIVE_LOADING,
	PULL_ARCHIVE_SUCCESS,
} from '../types';

const INITIAL_STATE = {
	loading: false,
	error: null,
	data: null,
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case PULL_ARCHIVE_LOADING:
			return {
				...state,
				loading: false,
				error: null,
			};
		case PULL_ARCHIVE_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				data: action.payload,
			};
		case PULL_ARCHIVE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
